import request from './base'

export const login = (params) => {
    return request.post("/merchant/v1/login", params)
}

export const sendCode = (params) => {
    return request.post("/merchant/v1/send/code", params)
}

export const checkCode = (params) => {
    return request.post("/merchant/v1/check/code", params)
}

export const resetPassword = (params) => {
    return request.post("/merchant/v1/reset/password", params)
}


// WEBPACK FOOTER //
// ./src/api/login.js